/** True on phones/tablets (touch-primary). Matches image gallery tap behavior in AssetGetByIdView. */
export function isCoarsePointerDevice(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(hover: none), (pointer: coarse)').matches;
}

/** True on typical PC browsers with a mouse — even when the app frame is narrow. */
export function isFinePointerDevice(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
}
